import { createFrontendRouter, createSlice } from '@metorial/microfrontend';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Link, Outlet } from 'react-router-dom';
import { Viewer } from './viewer';

import './reset.css';

(window as any).LinkComponent = Link;

export let accountSlice = createSlice([
  {
    path: '',
    element: <Viewer />
  }
]);

export let App = createFrontendRouter({
  frontends: [accountSlice('')],
  layout: <Outlet />
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
